// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

BCSfFilter.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
    // Hide debut's search bar on mobile, and show our search bar instead
    if (window.theme && theme.SearchDrawer && typeof theme.SearchDrawer.close == 'function') {
  		theme.SearchDrawer.close();
  	}
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    // Hide debut's search suggestion
  	if (jQ('.predictive-search-wrapper').length > 0){
        jQ('.predictive-search-wrapper').hide();
    }
};

function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
  /* console.log('closeSuggestionMobile'); */
  jQ(searchBoxId).autocomplete('close');
  jQ('.' + bcsffilter.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
  // Remove search box
  var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
  if (isCloseSearchBox) jQ('.bc-sf-search-suggestion-mobile-top-panel,.bc-sf-search-suggestion-mobile-overlay').hide();
  // Update current term for all search boxes
  setValueAllSearchBoxes();
  // Add back tabindex=-1
  jQ('.bc-sf-search-no-tabindex').attr('tabindex', -1);
  // Return scrolling of body
  if(jQ('body').hasClass(bcsffilter.getClass('searchSuggestionMobileOpen'))){    
    jQ('body').removeClass(bcsffilter.getClass('searchSuggestionMobileOpen'));
  }
  bcsffilter.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
  
  // Close search theme debut
  if(jQ('.js-drawer-close').length > 1){
    jQ('.js-drawer-close').trigger('click');
  }
}


// Displaying labels instead of prices for in store products and coming soon products in instant search results 
BCSfFilter.prototype.buildSuggestionProductPrice = function (a) {
  if (a.hasOwnProperty('product_type')) {
    if (a.tags.includes('soon')) {
      return 'Coming Soon';
    } else if (a.tags.includes('store_only')) {
      return 'Available in Store';
    } else {
      bcsffilter.prepareSuggestionProductPriceData(a);
      var b = a.compare_at_price_min > a.price_min,
        c = bcsffilter.formatMoney(100 * a.price_min),
        d = bcsffilter.formatMoney(100 * a.compare_at_price_min);
      bcsffilter.getSettingValue("search.removePriceDecimal") && (c = bcsffilter.removeDecimal(c), d = bcsffilter.removeDecimal(d));
      var e = "";
      return bcsffilter.getSettingValue("search.showSuggestionProductPrice") && (e += '<div class="' + bcsffilter.class.searchSuggestion + '-product-price">', b && bcsffilter.getSettingValue("search.showSuggestionProductSalePrice") ? (e += "<s>" + d + "</s>  ", e += '<span class="bc-sf-product-sale-price">' + c + "</span>") : e += '<span class="bc-sf-product-regular-price">' + c + "</span>", e += "</div>"), e
    }
  }
}